import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'components/button/ActionButton';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import styled, { keyframes } from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { RefreshIcon } from 'assets/materialIcons/materialIcons';
import { connect } from 'react-redux';
import { fetchOrderBookingActivitiesFailure, fetchOrderBookingActivitiesSuccess } from 'store/actions/orderActivitiesActions';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const LoadingRefreshIcon = styled(RefreshIcon)`
    animation: ${ rotate } 2s linear;
`;

class RefreshButton extends React.Component {
    state = {
        loading: false,
    }

    setLoading = (state) => {
        this.setState({
            loading: state,
        });
    }

    onClick = () => {
        const { onClick } = this.props;

        let timedOut = false;
        let called = false;

        this.setLoading(true);

        setTimeout(() => {
            timedOut = true;
            if (called) {
                this.setLoading(false);
            }
        }, 2000);

        onClick(() => {
            called = true;
            if (timedOut) {
                this.setLoading(false);
            }
        });
    }

    handleChange = () => {
        const { id, sendFailure, sendSuccess } = this.props;

        this.setState({
            loading: true,
        }, () => {
            const url = `${ config.getApiBaseUrl() }/bookings/${ id }/activities`;

            return apiClient.read(url).then((response) => {
                sendSuccess({
                    id: id,
                    response: response,
                });
            }, (error) => {
                sendFailure(error);
            }).then(() => {

                // This setTimeout will prevent the loading indicator from updating so the animation will run once.
                window.setTimeout(() => {
                    this.setState({
                        loading: false,
                    });
                }, 2000);
            });
        });
    }

    render() {
        const { translate } = this.props;
        const { loading } = this.state;

        return <FlatButton
            disabled={ loading }
            icon={ loading ?
                <LoadingRefreshIcon color={ theme.palette.primary1Color } /> :
                <RefreshIcon color={ theme.palette.primary1Color } />
            }
            hoverColor='rgba(0, 0, 0, 0.1)'
            labelPosition='after'
            onTouchTap={ this.onClick }
            title={ translate('actions.refresh') }
            onClick={ this.onClick }
            primary={ true }
            style={ {
                borderRadius: '0 0 0 5px',
            } }
        />;
    }
}

RefreshButton.propTypes = {
    id: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    sendFailure: PropTypes.func.isRequired,
    sendSuccess: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        sendFailure: (error) => {
            dispatch(fetchOrderBookingActivitiesFailure(error));
        },
        sendSuccess: (response) => {
            dispatch(fetchOrderBookingActivitiesSuccess(response));
        },
    };
};

export default connect(
    null,
    mapDispatchToProps,
)(translate(RefreshButton));



// WEBPACK FOOTER //
// ./src/components/button/RefreshButton.js